import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { setPurchaser } from '../../../actions/currentOrder';

const initialState = null as string | null;

const slice = createSlice({
  name: '$purchaserFamilyName',
  initialState,
  reducers: {
    setPurchaserFamilyName(state, action: PayloadAction<string | null>) {
      return action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(setPurchaser, (state, action) => {
      return action.payload.familyName;
    });
  },
});

export const { setPurchaserFamilyName } = slice.actions;
export default slice.reducer;
